import api from '../../api'
import { endpoints } from '../../apiCommons'

const verifyPasswordChange = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.verifyPasswordChange, {
    headers: { token },
    params: {
      sGuidLogin: token,
    },
  })
}

const reSendCodLoginEmpresa = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.ReSendCodLoginEmpresa, {
    headers: { token },
    params: {
      sGuidLogin: token,
    },
  })
}

const verifyCodLoginEmpresa = async (code) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.VerifyCodLoginEmpresa, {
    headers: { token },
    params: {
      sGuidLogin: token,
      sCode: code,
    },
  })
}

const verifyPasswordChange_Modal = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.VerifyPasswordChange_Modal, {
    headers: { token },
    params: {
      sGuidLogin: token,
    },
  })
}

const cambioContrasenaEmpresa_PrimerLogin = async (body) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.CambioContrasenaEmpresa_PrimerLogin, body, {
    headers: { token },
  })
}

export default {
  verifyPasswordChange,
  reSendCodLoginEmpresa,
  verifyCodLoginEmpresa,
  verifyPasswordChange_Modal,
  cambioContrasenaEmpresa_PrimerLogin,
}
